module.exports = __webpack_public_path__ + "img/457-47325f.png";